import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';

export class FascicoloImmobiliare extends FascicoloFull {
  sezione: string;
  valorePrecetto: string;
  conversionePignoramento: boolean;
  dataTrascrizioneRegistroImm: number;
  numRuoloDecretoRif: string;
  posizioneFascicoloRif: string;
  dataInizioFascicoloRif: number;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
